import classnames from 'classnames'
import { useNavigate } from 'react-router-dom'
import { shallow } from 'zustand/shallow'

import ButtonIcon from 'src/ui/atoms/Button/Icon'
import { useMenuStore } from 'src/store/menu'

import packageInfo from '../../../../package.json'
import { topMenu, bottomMenu, socials } from './menuItems'

const Navigation = () => {
  const navigate = useNavigate()
  const { opened, close } = useMenuStore(
    (state) => ({ opened: state.opened, close: state.close }),
    shallow,
  )

  return (
    <div
      className={classnames(
        'fixed hidden h-full flex-col justify-between px-4 md:flex md:w-[inherit] md:px-6',
        {
          'z-20 !flex w-full bg-navy-blue': opened,
        },
      )}>
      <div>
        <header className="flex items-center justify-between px-2 py-6 text-xl font-bold text-white">
          <a href={window.location.origin}>
            ZoidCore
            <span className="ml-1 align-super text-[6px] text-main-blue">
              {packageInfo.version}
            </span>
          </a>
          <ButtonIcon onClick={close} className="md:hidden" icon="close" type="text" size="S" />
        </header>
        <section className="grid gap-4">
          {topMenu.map(({ label, path, icon, dataCy, live }, key) => (
            <button
              className={classnames(
                'flex cursor-pointer flex-row items-center gap-2 py-2 font-spaceGrotesk text-white hover:text-main-blue',
                {
                  'pointer-events-none opacity-50': !live,
                },
              )}
              key={key}
              data-cy={dataCy}
              onClick={() => navigate(path)}>
              <span className={`icon-${icon} text-xl`} />
              <span className="text-sm"> {label} </span>
              {!live && (
                <span className="rounded-sm bg-white bg-opacity-30 p-1 text-xxs">Soon</span>
              )}
            </button>
          ))}
        </section>
      </div>

      <div>
        <section className="mb-4 mt-auto grid gap-4">
          {bottomMenu.map(({ label, url, icon, live }, key) => (
            <a
              className={classnames(
                'flex cursor-pointer flex-row items-center gap-2 font-spaceGrotesk text-white hover:text-main-blue',
                {
                  'pointer-events-none opacity-50': !live,
                },
              )}
              key={key}
              href={url}
              target="_blank"
              rel="noreferrer">
              <span className={`icon-${icon} text-xl`} />
              <span className="text-sm"> {label} </span>
              {!live && (
                <span className="rounded-sm bg-white bg-opacity-30 p-1 text-xxs">Soon</span>
              )}
            </a>
          ))}
        </section>

        <section className="grid grid-cols-3 gap-4 border-t border-white border-opacity-30 py-6">
          {socials.map(({ url, icon }, key) => (
            <a href={url} key={key} target="_blank" rel="noreferrer">
              <span className={`icon-${icon} text-xl text-white`} />
            </a>
          ))}
        </section>
      </div>
    </div>
  )
}

export default Navigation
